<template>
  <Loading v-if="isLoading" />
  <div v-else>
    <handle-product-sidebar ref="productSidebar" />

    <div class="flex justify-between">
      <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit.</p>
      <div class="flex justify-end">
        <vs-button icon="add" @click="onClickCreateNew" type="relief" color="primary" class="mr-3">Add new</vs-button>
      </div>
    </div>

    <!-- table -->
    <div class="data-list-list-view">
      <vs-table ref="table" class="mt-4" pagination search :max-items="10" :data="filteredSalesProducts" @selected="onClicked">
        <template slot="header">
          <div class="flex mb-2">
            <vs-select v-model="filters.salesGroup" autocomplete class="w-3/3">
              <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in selectableFilters.salesGroup" />
            </vs-select>
          </div>
          <vs-spacer />
        </template>

        <template slot="thead">
          <!-- <vs-th sort-key="id">Product id</vs-th> -->
          <vs-th sort-key="name">Name</vs-th>
          <vs-th>Sales group</vs-th>
          <!-- <vs-th>Sales sub group</vs-th> -->
          <vs-th sort-key="color">Color</vs-th>
          <vs-th sort-key="salesProductType">Type</vs-th>
          <!-- <vs-th sort-key="priceMax">Price max</vs-th> -->
          <!-- <vs-th sort-key="cogsMinPrice">Worst possible COGS</vs-th> -->
          <!-- <vs-th sort-key="cogsMaxPrice">COGS max</vs-th> -->
          <vs-th sort-key="createdAt">Created at</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <div class="product-name font-medium truncate flex flex-row items-center">
                  <div class="flex justify-start">
                    <img width="40" :src="ProductIcon" />
                    <div class="ml-4">
                      <div v-if="tr.name">
                        {{ tr.name }}
                      </div>
                      <div v-else>
                        <vs-chip> No name </vs-chip>
                      </div>
                      <small>{{ tr.shortId }}</small>
                    </div>
                  </div>
                </div>
              </vs-td>
              <vs-td>
                <vs-chip class="z-10 w-32 flex justify-start" :color="matchingSalesGroup(tr).color">
                  {{ matchingSalesGroup(tr).name }}
                </vs-chip>
              </vs-td>
              <!-- <vs-td class="relative">
                <vs-chip
                class="z-10 w-32 flex justify-start"
                  :color="matchingSalesGroup(tr).color"
                >
                  {{ matchingSalesSubGroup(tr).name }}
                </vs-chip>
              </vs-td> -->
              <vs-td class="pr-0">
                <vs-chip :color="tr.color" class="w-12"></vs-chip>
              </vs-td>
              <vs-td>
                {{ tr.salesProductType }}
              </vs-td>
              <!-- <vs-td>
                {{ tr.priceMax }}
                DKK
              </vs-td> -->
              <!-- <vs-td> {{ tr.cogsMinPrice.toFixed(2) }} % </vs-td> -->
              <!-- <vs-td> {{ tr.cogsMaxPrice.toFixed(2) }} % </vs-td> -->
              <vs-td>
                <div v-if="tr.createdAction" class="flex">
                  <feather-icon class="mr-1" :icon="'CalendarIcon'" svgClasses="text-grey w-5 h-5" />
                  {{ tr.createdAction.timestamp | formatDate }}
                </div>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ProductIcon from "@/assets/images/product-icon.png";
import HandleProductSidebar from "./SalesProductSidebar.vue";

export default {
  components: {
    HandleProductSidebar
  },
  data() {
    return {
      isLoading: true,
      ProductIcon,

      filters: {
        salesGroup: null
      }
    };
  },
  methods: {
    onClicked(item) {
      this.$refs.productSidebar.show(item.id);
    },
    async onClickCreateNew() {
      this.$refs.productSidebar.showEmptyProduct();
    },
    matchingSalesGroup(salesProduct) {
      return this.salesGroups.find(e => e.salesProductGroupId.id === salesProduct.salesProductGroupId);
    },
    matchingSalesSubGroup(salesProduct) {
      const match = this.salesSubGroups.find(e => e.salesProductSubGroupId.id === salesProduct.salesProductSubGroupId);
      return match && salesProduct.salesProductSubGroupId != "None" ? match : { name: "None", color: "grey" };
    }
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      countries: "pos/countries/countries",
      salesProducts: "pos/salesProducts/salesProducts",
      salesGroups: "pos/countrySettings/salesProductGroups",
      priceGroups: "pos/countrySettings/priceGroups"
    }),

    selectableFilters() {
      return {
        salesGroup: [
          { text: "Filter by sales group", value: null },
          ...this.salesGroups.map(e => ({
            text: e.name,
            value: e.salesProductGroupId.id
          }))
        ]
      };
    },

    filteredSalesProducts() {
      return this.salesProducts
        .filter(e => {
          if (this.filters.salesGroup && e.salesProductGroupId != this.filters.salesGroup) {
            return false;
          }

          return true;
        })
        .slice()
        .sort((a, b) => (a.createdAction.timestamp < b.createdAction.timestamp ? 1 : -1));
    }
  },

  async created() {
    this.isLoading = true;
    await Promise.all([
      this.$store.dispatch("pos/salesProducts/getSalesProducts"),
      this.$store.dispatch("pos/countrySettings/getCountrySettings")
      // this.$store.dispatch("pos/salesProducts/salesGroups/getSalesGroups"),
      // this.$store.dispatch("pos/salesProducts/salesGroups/getSalesSubGroups"),
    ]);
    this.isLoading = false;
  }
};
</script>